import { firestore } from '@psl/functions/firebase/firebaseAccess';

export const storeFrontDoc = (sellerId: string) =>
  firestore().collection('stores').doc(sellerId);
